let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("85wTz")]).then(() => parcelRequire('2zR3Z'));